import { Button as ButtonAntd } from 'antd';
import { ButtonProps } from 'antd/lib/button/button';
import React from 'react';

import styles from './Button.module.scss';

interface Props extends Omit<ButtonProps, 'style'> {
  children: React.ReactNode;
  style?: string;
  submit?: boolean;
}


const Button = ({style, type, submit, children, ...rest}:Props) => {
  return <ButtonAntd 
    className={`${style} ${type === 'link' ? styles.link : styles.main}` }
    block
    htmlType={submit ? 'submit' : 'button'}
    {...rest}
    >
    {children}
  </ButtonAntd>
}

export default Button;